module.exports = __webpack_public_path__ + "static/img/W.7c6c632.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/mjhl2/W.png
// module id = OCnM
// module chunks = 0